import { BorderRadiusTokens, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackHeight, StackJustifyContent, StackPositionType, StackType, StackWidth, WIDGET } from "@voltmoney/schema";
import { partnerHelpLineNumber } from "../../configs/constants";
import { isMobile } from "../../configs/utils";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
const _isMobile = isMobile();
export const PartnerHeader = async (route, isFromPlatform, action) => {
    const DS = {
        partnerHeader: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'headerChildContainer', type: WIDGET.STACK },
                {
                    id: 'headerDivider',
                    type: WIDGET.DIVIDER,
                },
            ],
        },
        headerDivider: {
            size: DividerSizeTokens.SM,
            color: ColorTokens.Grey_Chalk,
        },
        headerChildContainer: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            maxWidth: 1600,
            padding: _isMobile ? {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL
            } : {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                top: route === ROUTE.PLATFORM_SIGN_UP ? SizeTypeTokens.MD : SizeTypeTokens.NONE,
                bottom: route === ROUTE.PLATFORM_SIGN_UP ? SizeTypeTokens.MD : SizeTypeTokens.NONE
            },
            alignItems: StackAlignItems.center,
            widgetItems: [
                _isMobile ? { id: 'menuItemStack', type: WIDGET.STACK } : {},
                { id: 'leftHeaderContainer', type: WIDGET.STACK },
                { id: 'rightHeaderContainer', type: WIDGET.STACK },
            ],
        },
        leftHeaderContainer: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.center,
            widgetItems: [
                { id: 'voltPartnerLogo', type: WIDGET.ICON },
                isFromPlatform ? {} : { id: 'voltPartnerT1Stack', type: WIDGET.STACK }
            ],
            action: {
                routeId: route,
                type: ACTION.GO_TO_HOME,
                payload: {}
            }
        },
        menuItemStack: {
            type: StackType.row,
            width: StackWidth.CONTENT,
            padding: {
                right: SizeTypeTokens.LG
            },
            widgetItems: [{
                    id: 'menuItemStackIcon', type: WIDGET.ICON
                }],
            action: {
                routeId: route,
                type: ACTION.OPEN_MENU,
                payload: {}
            }
        },
        menuItemStackIcon: {
            name: IconTokens.ThreeBar,
            size: IconSizeTokens.XXL
        },
        voltPartnerT1Stack: {
            type: StackType.row,
            width: StackWidth.CONTENT,
            padding: {
                top: SizeTypeTokens.Size32,
                left: SizeTypeTokens.XS
            },
            position: StackPositionType.relative,
            positionConfig: {
                bottom: SizeTypeTokens.MD
            },
            widgetItems: [{
                    id: 'voltPartnerT1', type: WIDGET.TEXT
                }],
        },
        voltPartnerT1: {
            label: `Partners`,
            fontWeight: '600',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.XS,
            color: ColorTokens.Primary_100,
            lineHeight: 18,
        },
        rightHeaderContainer: {
            type: StackType.row,
            flex: 1,
            padding: {
                top: SizeTypeTokens.MD,
                bottom: SizeTypeTokens.MD
            },
            height: StackHeight.MATCH_PARENT,
            justifyContent: StackJustifyContent.flexEnd,
            alignItems: StackAlignItems.center,
            widgetItems: [
                _isMobile || route !== ROUTE.PARTNER_SIGNUP || route !== ROUTE.PLATFORM_SIGN_UP ? {} : {
                    id: 'backToHomePageStack',
                    type: WIDGET.STACK,
                },
                {
                    id: 'partnerSignUpS0',
                    type: WIDGET.SPACE
                },
                _isMobile ? {} : {
                    id: 'needHelpStack',
                    type: WIDGET.STACK,
                },
                {
                    id: 'partnerSignUpS1',
                    type: WIDGET.SPACE
                },
                {
                    id: 'phoneNumberStack',
                    type: WIDGET.STACK,
                },
                {
                    id: 'partnerSignUpS2',
                    type: WIDGET.SPACE
                },
                {
                    id: 'chatWithUsStack',
                    type: WIDGET.STACK,
                },
                route === ROUTE.PARTNER_SIGNUP || route === ROUTE.PLATFORM_SIGN_UP || isFromPlatform ? {} : {
                    id: 'partnerSignUpS3',
                    type: WIDGET.SPACE
                },
                _isMobile || route === ROUTE.PARTNER_SIGNUP || isFromPlatform || route === ROUTE.PLATFORM_SIGN_UP ? {} : {
                    id: 'faqStack',
                    type: WIDGET.STACK
                },
                _isMobile || route === ROUTE.PARTNER_SIGNUP || route === ROUTE.PLATFORM_SIGN_UP || isFromPlatform ? {} : {
                    id: 'partnerSignUpS4',
                    type: WIDGET.SPACE
                },
                _isMobile || route === ROUTE.PARTNER_SIGNUP || route === ROUTE.PLATFORM_SIGN_UP ? {} : {
                    id: 'logoutStack',
                    type: WIDGET.STACK,
                },
            ],
        },
        whatsAppSpace: {
            size: SizeTypeTokens.XL
        },
        faqStack: {
            type: StackType.row,
            widgetItems: [{ id: 'faqStackT1', type: WIDGET.TEXT }, { id: 'faqStackT2', type: WIDGET.TEXT }],
            action: {
                routeId: route,
                type: ACTION.GO_TO_FAQ,
                payload: {}
            }
        },
        faqStackT1: {
            label: `Have any doubts? `,
            fontWeight: '500',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Charcoal,
            lineHeight: 20,
        },
        faqStackT2: {
            label: `FAQ`,
            fontWeight: '500',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Primary_100,
            lineHeight: 20,
        },
        backToHomePageStack: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            widgetItems: [{ id: 'backtoHomePageT1', type: WIDGET.TEXT }],
            action: {
                routeId: route,
                type: ACTION.GO_TO_HOME,
                payload: {}
            }
        },
        backtoHomePageT1: {
            label: `Back to homepage`,
            fontWeight: '500',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Night,
            lineHeight: 20,
        },
        needHelpStack: {
            type: StackType.row,
            widgetItems: [{ id: 'needHelpT1', type: WIDGET.TEXT }],
        },
        needHelpT1: {
            label: `Need help?`,
            fontWeight: '500',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Night,
            lineHeight: 20,
        },
        phoneNumberStack: {
            type: StackType.row,
            widgetItems: [
                { id: 'phoneNumberStackIcon1', type: WIDGET.ICON },
                _isMobile ? {} : { id: 'phoneNumberS1', type: WIDGET.SPACE },
                _isMobile ? {} : { id: 'phoneNumberStackT1', type: WIDGET.TEXT },
            ],
            action: {
                routeId: route,
                type: ACTION.GO_TO_CALL,
                payload: {}
            }
        },
        phoneNumberStackIcon1: {
            name: IconTokens.Phone,
            color: ColorTokens.Primary_100,
            size: _isMobile ? IconSizeTokens.XXL : IconSizeTokens.LG,
        },
        phoneNumberStackT1: {
            label: `${partnerHelpLineNumber}`,
            fontWeight: '500',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Primary_100,
            lineHeight: 20,
        },
        chatWithUsStack: {
            type: StackType.row,
            widgetItems: [
                { id: 'whatsappStackIcon1', type: WIDGET.ICON },
                _isMobile ? {} : { id: 'whatsAppS1', type: WIDGET.SPACE },
                _isMobile ? {} : { id: 'whatsappStackT1', type: WIDGET.TEXT },
                _isMobile ? {} : { id: "whatsAppSpace", type: WIDGET.SPACE }
            ],
            action: {
                routeId: route,
                type: ACTION.GO_TO_WHATSAPP,
                payload: {}
            }
        },
        logoutStack: {
            type: StackType.row,
            padding: {
                all: _isMobile ? SizeTypeTokens.Size1 : SizeTypeTokens.LG
            },
            bgColor: _isMobile ? ColorTokens.White : ColorTokens.Grey_Chalk,
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR5
            },
            widgetItems: [
                {
                    id: 'logoutIcon', type: WIDGET.ICON
                }
            ],
            action: {
                routeId: route,
                type: ACTION.LOGOUT,
                payload: {}
            }
        },
        logoutIcon: {
            name: IconTokens.Logout,
            size: _isMobile ? IconSizeTokens.XXL : IconSizeTokens.LG,
            color: ColorTokens.Grey_Charcoal
        },
        whatsappStackIcon1: {
            name: IconTokens.Whatsapp,
            size: _isMobile ? IconSizeTokens.XXL : IconSizeTokens.LG,
        },
        whatsappStackT1: {
            label: `Chat with us`,
            fontWeight: '500',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Primary_100,
            lineHeight: 20,
        },
        voltPartnerLogo: {
            name: isFromPlatform ? IconTokens.VoltPlatform : IconTokens.VoltFull,
            size: IconSizeTokens.XXXXXXXL,
        },
        phoneNumberS1: {
            size: SizeTypeTokens.SM,
        },
        whatsAppS1: {
            size: SizeTypeTokens.SM,
        },
        partnerSignUpS0: {
            size: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXL,
        },
        partnerSignUpS1: {
            size: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXL,
        },
        partnerSignUpS2: {
            size: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXL,
        },
        partnerSignUpS3: {
            size: _isMobile || isFromPlatform ? SizeTypeTokens.XL : SizeTypeTokens.XXXL,
        },
        partnerSignUpS4: {
            size: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXL,
        },
    };
    return DS;
};
